// Node Module Imports
import React from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Component Imports
import { above, colors, space } from '../../style/design-system'
import Chevron from '../uma-svgs/Chevron'

// Style Imports

const HeroChevron = ({
  backgroundImage,
  backgroundImageMobile,
  borderColor,
  children,
  className,
  displayOverflow,
  noImage,
  noFloatingChevrons,
}) => (
  <div className={`${className} d-flex`}>
    {!noFloatingChevrons && (
      <>
        <Chevron
          className="floater-one position-absolute d-none d-md-block"
          color={colors.dev.blue.e(0.8)}
          direction="northeast"
          width="40px"
          height="40px"
        />
        <Chevron
          className="floater-two position-absolute d-none d-md-block"
          color={colors.dev.yellow.e(0.8)}
          direction="northeast"
          width="72px"
          height="72px"
        />
        <Chevron
          className="floater-three position-absolute d-none d-md-block"
          color={colors.dev.pink.e(0.8)}
          direction="northeast"
          width="56px"
          height="56px"
        />
      </>
    )}

    {!noImage && (
      <>
        <GatsbyImage
          className="d-sm-none"
          image={backgroundImageMobile.image}
          objectPosition={backgroundImageMobile.objectPosition}
          alt=""
          style={{
            position: 'absolute',
            width: '100%',
            height: 'auto',
            top: 0,
            bottom: 0,
            zIndex: -2,
          }}
          imgStyle={{ zIndex: '-1' }}
          loading="eager"
        />
        <GatsbyImage
          className="d-none d-sm-block"
          image={backgroundImage.image}
          objectPosition={backgroundImage.objectPosition}
          imgStyle={{ ...backgroundImage.imgStyle, zIndex: '-1' }}
          alt=""
          style={{
            position: 'absolute',
            width: '100%',
            height: 'auto',
            top: 0,
            bottom: 0,
            zIndex: -2,
          }}
          loading="eager"
        />
      </>
    )}

    <div className="mobile-green" />
    <div className="mobile-triangle" />

    <div className="triangle">
      <div className="inner">
        <div className="bg--blue-chev north" />
      </div>
    </div>

    <div className="container content-container">
      <div className="hero__content">{children}</div>
    </div>
  </div>
)

HeroChevron.propTypes = {
  borderColor: PropTypes.string.isRequired,
  backgroundImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  displayOverflow: PropTypes.bool,
  noImage: PropTypes.bool,
  noFloatingChevrons: PropTypes.bool,
}

HeroChevron.defaultProps = {
  backgroundImage: '',
  noImage: false,
  noFloatingChevrons: false,
}

export default styled(HeroChevron)`
  align-items: flex-end;
  // min-height: 600px;
  position: relative;
  padding-bottom: ${space.e};

  ${(props) => (!props.displayOverflow ? 'overflow: hidden;' : '')}

  ${above.sm`
    align-items: center;
    padding-bottom: 0;
  `}
  
  // ${above.md`
  //   max-height: 1200px;
  //   min-height: 84vh;
  // `}


  .content-container {
    align-items: flex-end;
    display: flex;
    min-height: 600px;
    z-index: 3;

    // IE10+ only
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      min-height: auto;
      padding-top: 350px;
    }

    ${above.sm`
    padding-top: 225px;
    padding-bottom: 225px;
      align-items: center;
    `}

    ${above.md`
      max-height: 1200px;
      min-height: 84vh;
    `}
  }

  .triangle {
    height: 2000px;
    overflow: hidden;
    position: absolute;
    bottom: 100px;
    right: calc(20px + ((334 / 393) * (100vw - 375px)));
    transform: rotate(-45deg);
    transform-origin: bottom right;
    width: 2000px;
    z-index: 2;

    ${above.sm`
      bottom: 50%;
      border: ${(props) => `40px solid ${props.borderColor}`};
      border-radius: 2px;
      right: 30%;
    `}

    ${above.lg`
      right: 35%;
    `}

    ${above.xl`
      right: 45%;
    `}

    .inner {
      height: 1960px;
      width: 1960px;
    }

    .bg--blue-chev {
      transform: rotate(135deg);
      width: 200%;
    }
  }

  .mobile-green {
    background-color: ${(props) => props.borderColor};
    height: 101px;
    position: absolute;
    right: 0;
    left: 0;
    bottom: calc(162px + ((145 / 170) * (100vw - 375px)));
    transform: rotate(-45deg);
    transform-origin: top right;
    /* z-index: -2; */

    ${above.sm`
      display: none;
    `}
  }

  .mobile-triangle {
    background-color: #fff;
    height: calc(170px + ((288 / 240) * (100vw - 375px)));
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(50%, 50%) rotate(-45deg);
    width: 100%;
    z-index: 1;

    ${above.sm`
      display: none;
    `}
  }

  .hero__content {
    max-width: 56%;

    ${above.sm`
      margin-top: 0;
      max-width: 35%;
      transform: translate(-1.5rem, -3rem);
    `}

    ${above.md`
      transform: translate(0, 0);
    `}
  }

  .floater-one {
    top: ${space.f};
    right: ${space.f};
  }

  .floater-two {
    top: ${space.h};
    right: 40%;

    ${above.lg`
      right: 45%;
    `}

    ${above.xl`
      right: 50%;      
    `}
  }

  .floater-three {
    top: ${space.l};
    right: ${space.f};
  }
`
